"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const kendo_react_dropdowns_1 = require("@progress/kendo-react-dropdowns");
const CustomAutoComplete = (_a) => {
    var { label, containerStyle, error, errorMessage } = _a, props = __rest(_a, ["label", "containerStyle", "error", "errorMessage"]);
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ style: Object.assign({ padding: 0 }, containerStyle), className: 'custom-input-container', "data-testid": 'label-autocomplete-testid' }, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ className: 'did-floating-label-content ' + (error ? 'did-error-input' : '') }, { children: [(0, jsx_runtime_1.jsx)(kendo_react_dropdowns_1.AutoComplete, Object.assign({}, props)), label && ((0, jsx_runtime_1.jsx)("label", Object.assign({ className: 'did-floating-label' }, { children: label })))] })), error && ((0, jsx_runtime_1.jsx)("small", Object.assign({ hidden: !error, className: 'error-label', "data-testid": 'error-autocomplete-testid' }, { children: errorMessage })))] })));
};
exports.default = CustomAutoComplete;
